// Perception (Mercury): five-letter words score more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import type { AlignmentDef } from '../types';

export const perception: AlignmentDef = {
  id: 'perception',
  planet: 'mercury',
  name: 'Perception',
  text: () => `${N.perceptionLength}-letter words score +${N.perceptionPercent}%.`,
  wordPercent: (c) => (c.nodes.length === N.perceptionLength ? N.perceptionPercent : 0),
};
